// extracted by mini-css-extract-plugin
module.exports =  {"copyValue":"style-module_copyValue__US4WOx896SQITTUb8IEP"};